import { createEvent } from 'effector';

const pageMounted = createEvent<boolean>();

export const $$utils = {
  pageMounted
};
